const ProductReducer = (state, action) => {
  switch (action.type) {
    case "setOrginalProducts":
      return { ...state, originalProducts: action.payload };
    case "setProducts":
      return { ...state, products: action.payload };
    case "setTotalProducts":
      return {
        ...state,
        originalProducts: action.payload,
        products: action.payload
      };
    case "setOrderHistory":
      return { ...state, orders: action.payload };
    case "setCartIds": {
      const updatedProducts = Array.isArray(action.payload) ? action.payload : [action.payload];

      const newCartIds = [...state.cartIds];

      updatedProducts.forEach(product => {
        const index = newCartIds.findIndex(item => item === product);
        if (index >= 0) {
          newCartIds[index] = product; // update
        } else {
          newCartIds.push(product); // add
        }
      });

      return {
        ...state,
        cartIds: newCartIds
      };
    }
    case "setRemoveCartIds":
      return {
        ...state,
        cartIds: state.cartIds.filter(item => item !== action.payload)
      };
    case "setCart":
      {

        const updatedProducts = Array.isArray(action.payload) ? action.payload : [action.payload];

        const newCarts = [...state.cart];

        updatedProducts.forEach(product => {
          const index = newCarts.findIndex(item => item.prdId === product.prdId);
          if (index >= 0) {
            newCarts[index] = product; // update
          } else {
            newCarts.push(product); // add
          }
        });

        return {
          ...state,
          cart: newCarts
        };
      }
    case "setRemoveCart":
      return {
        ...state,
        cart: state.cart.filter(item => item.prdId !== action.payload.prdId)
      };
    case "setWishlistIds": {
      const updatedProducts = Array.isArray(action.payload) ? action.payload : [action.payload];

      const newWhislistIds = [...state.wishlistIds];

      updatedProducts.forEach(product => {
        const index = newWhislistIds.findIndex(item => item === product);
        if (index >= 0) {
          newWhislistIds[index] = product; // update
        } else {
          newWhislistIds.push(product); // add
        }
      });

      return {
        ...state,
        wishlistIds: newWhislistIds
      };
    }
    case "setRemoveWishlistIds":
      return {
        ...state,
        wishlistIds: state.wishlistIds.filter(item => item !== action.payload)
      };
    case "setWishlist":
      {
        const updatedProducts = Array.isArray(action.payload) ? action.payload : [action.payload];

        const newWhislist = [...state.wishlist];

        updatedProducts.forEach(product => {
          const index = newWhislist.findIndex(item => item.prdId === product.prdId);
          if (index >= 0) {
            newWhislist[index] = product; // update
          } else {
            newWhislist.push(product); // add
          }
        });

        return {
          ...state,
          wishlist: newWhislist
        };
      }
    case "setRemoveWishlist":
      return {
        ...state,
        wishlist: state.wishlist.filter(item => item.prdId !== action.payload.prdId)
      };
    case "setCategories":
      return { ...state, categories: action.payload };
    case "setNewArrivalProducts":
      return { ...state, newArrivalProducts: action.payload };
    case "setCartReset":
      return { ...state, cart: [] };
    case "setCartIdsReset":
      return { ...state, cartIds: [] };
    case "setTotalReset":
      return {
        ...state,
        cart: [],
        wishlist: [],
        cartIds: [],
        wishlistIds: []
      };
    case "setMaxMinPrice":
      return { ...state, maxMinPrice: action.payload };
    case "setMovementType":
      return { ...state, listMovementType: action.payload };
    case "setPersonType":
      return { ...state, listPersons: action.payload };
    default:
      return state;
  }
};
export { ProductReducer };
